/* eslint-disable no-nested-ternary */
import React from "react";
import { StyledButton } from "./styles";

const IconButton = ({
  title = "",
  icon,
  isShopify = false,
  variant = "default",
  iconSize = "20px",
  ...rest
}) => (
  <StyledButton
    $variant={variant}
    $iconSize={iconSize}
    $isShopify={isShopify}
    {...rest}
  >
    {icon}

    {title}
  </StyledButton>
);

export default IconButton;
